import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Table,
    Input,
    Button,
    FormGroup,
    Label
} from 'reactstrap';
/**
 * Used for the Listino Prezzi section. 
 */
export class StimaOrdine extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: false, 
            costoTrasporto: 0,
            sogliaCostoTrasporto: 0,
            checkboxChecked: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount = () => {
        fetch("api/ordini/caricaAppSettings", {
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json'
            }),
            //Changes the response to an object
        }).then(response => response.json())
            .then(myjson => {
                console.log(myjson);
                this.setState({
                    costoTrasporto: myjson.costoTrasporto,
                    sogliaCostoTrasporto: myjson.sogliaCostoTrasporto
                })
            }).catch(e => {
                console.log(e);
            }); 
    }

    handleChange(event) {
        const checkedValue = event.target.checked;
        this.setState({
            checkboxChecked: event.target.checked
        })
        console.log(checkedValue);

        this.props.handleChange(checkedValue, this.state.costoTrasporto, this.state.sogliaCostoTrasporto);
    };
    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
   
    toggleModal = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    /**
     * Renders the page
     */

    render() {

        const titolo = (
            <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Stima Ordine</h5>
        );

        return (
            <Container fluid> 
                <Container className="d-flex align-items-center" fluid> 
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                            {titolo}
                        </Col>
                    </Row>
                </Container>
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Table responsive borderless style={{width: "100%", margin: "0", marginTop: "5px"}}>
                                    <tbody style={{fontSize: "24px"}}>                                     
                                        <tr>
                                        <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Stima:  </th>
                                        {/*<td align="left" style={{ padding: "0", paddingLeft: "20px" }}> € {this.props.totalStimaAfterSconti.toFixed(2) <= 300 && this.state.costoTrasportoCheck ? (this.props.totalStimaAfterSconti + 15).toFixed(2) + "*" : this.props.totalStimaAfterSconti.toFixed(2)}</td>*/}
                                        <td align="left" style={{ padding: "0", paddingLeft: "20px" }}> € {this.props.totalStimaAfterSconti.toFixed(2)}</td>
                                        </tr>                                    
                                        <tr>
                                            <th style={{height: "2px", width: "50%", padding: "0", textAlign: "right"}}><hr align="right" style={{backgroundColor: "#011e41", marginTop: "0", marginBottom: "0", width:"100%"}}/> </th>
                                            <td align="left" style={{height: "2px", padding: "0"}}><hr align="left" style={{backgroundColor: "#011e41", margin: "0", width:"100%"}}/></td>
                                        </tr>
                                        <tr>
                                        <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Totale:  </th>
                                        {this.props.applicato40 == true ?
                                            <td align="left" style={{ padding: "0", paddingLeft: "20px" }}> € {this.props.sconto40.toFixed(2)}<sup>*sconto 40Kg</sup></td> :
                                            this.props.applicato80 == true?
                                                <td align="left" style={{ padding: "0", paddingLeft: "20px" }}> € {this.props.sconto80.toFixed(2)}<sup>*sconto 80Kg</sup></td> :
                                                <td align="left" style={{ padding: "0", paddingLeft: "20px" }}> € {this.props.totalStimaAfterSconti.toFixed(2) <= 300 && this.state.checkboxChecked ? (this.props.totalStimaAfterSconti + this.state.costoTrasporto).toFixed(2) + "*" : this.props.totalStimaAfterSconti.toFixed(2)}</td>
                                        }
                                        </tr>
                                        <tr>
                                        <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Peso Stimato:  </th>
                                        <td align="left" style={{ padding: "0", paddingLeft: "20px" }}>{this.props.totalQta.toFixed(2)} Kg</td>
                                        </tr>
                                        <tr>
                                            <th style={{width: "50%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Data di Consegna:  </th>
                                            <td align="left" style={{padding: "0", paddingLeft: "20px"}}> 
                                                <Input type="date" name="dataDiConsegna" id="dataDiConsegna" style={{height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleOrdineDateChange} value={this.props.ordineDataConsegna}/>
                                            </td>
                                        </tr>
                                        <tr>
                                        <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Note:  </th>
                                        <td align="left" style={{ padding: "0", paddingLeft: "20px" }}>
                                            <Input type="textarea" id="note" name="note" style={{ height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px" }} onChange={this.props.handleNoteOrdineChange} value={this.props.noteOrdine}/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>                                    
                            </Col>
                    </Row>
                </Container>
                {/*<Container className="d-flex align-items-center" fluid>*/}
                {/*    {this.props.totalStima <= 300 ? */}
                {/*        <Row className="d-flex justify-content-center align-items-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>*/}
                {/*            <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>*/}
                {/*                <FormGroup style={{margin: "0px"}}>*/}
                {/*                    <Input*/}
                {/*                        type="checkbox"*/}
                {/*                        checked={this.state.checkboxChecked}*/}
                {/*                        onChange={this.handleChange}*/}
                {/*                        style={{marginTop: "12px"}}*/}
                {/*                    />*/}
                {/*                    <Label>*/}
                {/*                        Aggiungi € 15,00 per il trasporto*/}
                {/*                    </Label>*/}
                {/*                </FormGroup>*/}
                {/*            </Col>*/}
                {/*        </Row> : null*/}
                {/*    }*/}
                {/*</Container>*/}

                <Container className="d-flex align-items-center" fluid>
                    {this.props.avanzateBtn == true ?
                        <Row className="d-flex justify-content-center align-items-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                            <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                <Button type="button" className="text-center" onClick={this.props.toggleAvanzate} style={{ width: '30%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }}>
                                    Avanzate
                                </Button>
                            </Col>
                        </Row> : null
                    }
                </Container>
                <Container className="d-flex align-items-center" fluid>
                    <hr align="left" style={{ backgroundColor: "#011e41", margin: "0", width: "100%" }} />
                </Container>
                {this.props.sconti == true ?                    
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                        <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>                           
                            <Button type="radio" style={{ width: '30%', padding: '2px', backgroundColor: "#011e41", fontSize: "20px" }} disabled={!this.props.sconto40Btn} onClick={this.props.handleNessuno}> Nessuno</Button>
                            <Button type="radio" style={{ width: '30%', padding: '2px', backgroundColor: "#011e41", fontSize: "20px" }} disabled={!this.props.sconto40Btn} onClick={this.props.handleSconto40}>Sconto 40kg</Button>
                            <Button type="radio" style={{ width: '30%', padding: '2px', backgroundColor: "#011e41", fontSize: "20px" }} disabled={!this.props.sconto80Btn} onClick={this.props.handleSconto80}>Sconto 80kg</Button>
                        </Col>
                    </Row> : null
                }
                {this.props.totalStimaAfterSconti <= this.state.sogliaCostoTrasporto && this.state.checkboxChecked ?
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                        <p style={{ fontSize: 20, fontStyle: "italic", marginBottom: -5 }}>*il totale comprende € {this.state.costoTrasporto.toFixed(2)} in più per il trasporto</p>
                    </Row> : null
                }                
            </Container>
        )
    }
}

//VISUALIZZAZIONE SCONTI 40-80Kg

/*{this.props.sconto40Btn == true?
<tr>
    <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Sconto 40Kg: </th>
    <td align="left" style={{ padding: "0", paddingLeft: "20px" }}>-€ {(this.props.totalStima - this.props.sconto40).toFixed(2)} -- {this.props.applicato40}</td>
</tr> : null
                                    }

<tr>
    <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Sconto 80Kg: </th>
    <td align="left" style={{ padding: "0", paddingLeft: "20px" }}>-€ </td>
</tr>*/


// WEBPACK FOOTER //
// ./src/components/NuovoOrdine/StimaOrdine.js